import { render } from "./OrderInvoiceReceipt.vue?vue&type=template&id=189bfce0"
import script from "./OrderInvoiceReceipt.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__